import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import { AddOfferPopupModal } from 'features/discount-code/components/modal/add-offer-popup-modal';
import { useState } from 'react';
import { CompanyType } from 'types';
const { useBreakpoint } = Grid;

export const OfferPopupTopBar = ({
  initialValues,
  handleFilter,
  form,
}: any) => {
  useState<CompanyType>();
  const screens = useBreakpoint();

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ContentTopBar
        title={'Popup Banner'}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => {
                setShowModal(true);
                document.body.style.overflow = 'hidden';
              }}
            >
              Add Popup
            </Button>
            {showModal && (
              <AddOfferPopupModal
                onClose={() => setShowModal(false)}
                initialValues={initialValues}
                handleFilter={handleFilter}
                filterForm={form}
              />
            )}
          </>
        }
      />
    </>
  );
};
